// extracted by mini-css-extract-plugin
export default {"link":"_1hIZFUeF49","icon":"_FuetW4foY","link-active":"_1MBcYGGut_","linkActive":"_1MBcYGGut_"};
    if(module.hot) {
      // 1625219389656
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  